import React from 'react'
import DealDemo from './DealDemo';

export default function BlockdealsDemo(props) {
    const getRec = props.getblockData;

    return (
        <>
            {getRec ?
                <table className="table table-bordered">
                    <thead>
                        <tr className="header-row changefont">
                            <th className="indexname" size="3">Symbol</th>
                            <th className="ltp" size="3">LTP</th>
                            <th className="signal" size="3">Signal</th>
                            <th className="change" size="3">%CHG</th>
                            <th> Info </th>
                        </tr>
                    </thead>
                    <tbody>
                        {getRec.map((item, key) => (
                            <DealDemo key={key} mapdata={item} />
                        ))}
                    </tbody>
                </table>
                : ''}
        </>
    )
}
